module.exports = __webpack_public_path__ + "static/media/bg-pic-travels.21bbc212.jpg";